var ur = window.location.href;

  jQuery(document).ready(function(){

    
      
     jQuery('span.quickview-button').click(function(){
  		var q = jQuery(this).closest('.card.item-box');
        var qv = 0; var timerqv = setInterval(function(){
          if(q.find('.qview-button').length) {
		q.find('.qview-button').eq(0).click();
      clearInterval(timerqv);}if( qv > 200){clearInterval(timerqv);}qv++;}, 50);
        
});
    });
 